import React, { useState } from "react";

export default function Validator() {
  const [store, setStore] = useState("GooglePlay");
  const [productId, setProductId] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [unityReceipt, setUnityReceipt] = useState("");
  const [uiPassword, setUiPassword] = useState("");
  const [result, setResult] = useState("");

  async function submit(e) {
    e.preventDefault();
    setResult("...");

    const r = await fetch("/api/validate-ui-submit", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        uiPassword,
        store,
        productId,
        transactionId,
        unityReceipt,
      }),
    });

    const text = await r.text();
    setResult(text);
  }

  return (
    <div
      style={{ maxWidth: 900, margin: "40px auto", fontFamily: "sans-serif" }}
    >
      <h1>Receipt validator</h1>

      <form onSubmit={submit}>
        <div style={{ marginTop: 12 }}>
          <label>UI password</label>
          <input
            value={uiPassword}
            onChange={(e) => setUiPassword(e.target.value)}
            style={{ width: "100%" }}
          />
        </div>

        <div style={{ marginTop: 12 }}>
          <label>Store</label>
          <select value={store} onChange={(e) => setStore(e.target.value)}>
            <option value="GooglePlay">GooglePlay</option>
            <option value="AppleAppStore">AppleAppStore</option>
          </select>
        </div>

        <div style={{ marginTop: 12 }}>
          <label>productId</label>
          <input
            value={productId}
            onChange={(e) => setProductId(e.target.value)}
            style={{ width: "100%" }}
          />
        </div>

        <div style={{ marginTop: 12 }}>
          <label>transactionId</label>
          <input
            value={transactionId}
            onChange={(e) => setTransactionId(e.target.value)}
            style={{ width: "100%" }}
          />
        </div>

        <div style={{ marginTop: 12 }}>
          <label>unityReceipt (JSON)</label>
          <textarea
            value={unityReceipt}
            onChange={(e) => setUnityReceipt(e.target.value)}
            rows={12}
            style={{ width: "100%" }}
          />
        </div>

        <button style={{ marginTop: 12 }} type="submit">
          Validate
        </button>
      </form>

      <pre style={{ marginTop: 16, whiteSpace: "pre-wrap" }}>{result}</pre>
    </div>
  );
}
